// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginPage_container__2rogs","languageSelector":"LoginPage_languageSelector__1B8G7"};